frappe.views.dodock_drawer = class BaseDrawer {
	// @dokos
	/**
	 * @param {string} title - The title of the overlay.
	 * @param {object} parent - The parent wrapper for the overlay (jQuery). Defaults to document.body.
	 * @param {string} animation_type - "width" (default, list views) or "slide" (form views).
	 * @param {boolean} backdrop - Whether to render a clickable backdrop behind the panel.
	 * @param {string} open_width - Width of the panel when open. Defaults to "32rem".
	 */
	constructor(opts) {
		Object.assign(this, opts);

		if (!this.parent) {
			return;
		}
		this.animation_type = this.animation_type || "width";
		this.open_width = this.open_width || "32rem";

		this.sidebar = this.build_sidebar();
		this.parent[0].appendChild(this.sidebar);
		this.showSidebar = false;

		if (this.backdrop) {
			this._build_backdrop();
		}

		this.bind_close_button();
	}

	_build_backdrop() {
		this._backdropEl = document.createElement("div");
		this._backdropEl.classList.add("list-overlay-backdrop");
		document.body.appendChild(this._backdropEl);
		this._backdropEl.addEventListener("click", () => this.close());
	}

	build_sidebar() {
		const wrapper = document.createElement("div");
		wrapper.classList.add(
			"list-overlay-sidebar",
			"position-fixed",
			"shadow-lg",
			"overflow-hidden",
			"d-flex",
			"flex-column"
		);

		if (this.animation_type === "slide") {
			wrapper.style.width = this.open_width;
			wrapper.style.transform = "translateX(100%)";
			wrapper.style.transition = "transform 0.28s cubic-bezier(0.4,0,0.2,1)";
			wrapper.style.zIndex = "1050";
		} else {
			wrapper.style.width = "0";
			wrapper.style.transition = "width 0.3s ease";
		}

		wrapper.style.height = "calc(100vh - var(--navbar-height))";

		this.topSection = document.createElement("div");
		this.topSection.classList.add(
			"d-flex",
			"align-items-center",
			"justify-content-between",
			"p-3",
			"border-bottom"
		);

		this.titleSection = document.createElement("div");
		this.titleSection.classList.add("mb-0", "list-overlay-title");
		this.titleSection.innerText = this.title || "";

		// rightSection groups any extra controls + the close button on the right
		this.rightSection = document.createElement("div");
		this.rightSection.classList.add("d-flex", "align-items-center");
		this.rightSection.style.gap = "0.5rem";
		this.rightSection.style.flexShrink = "0";

		this.closingButton = document.createElement("a");
		this.closingButton.classList.add("collapse-sidebar-overlay");

		this.closingIcon = document.createElement("svg");
		this.closingIcon.classList.add("icon");
		this.closingIcon.innerHTML = frappe.utils.icon("arrow-right-to-line");

		this.closingButton.appendChild(this.closingIcon);
		this.rightSection.appendChild(this.closingButton);

		this.topSection.appendChild(this.titleSection);
		this.topSection.appendChild(this.rightSection);

		wrapper.appendChild(this.topSection);

		this.mainSection = document.createElement("div");
		this.mainSection.classList.add("list-overlay-body");

		wrapper.appendChild(this.mainSection);

		this.bottomSection = document.createElement("div");
		this.bottomSection.classList.add("list-overlay-footer");
		wrapper.appendChild(this.bottomSection);

		return wrapper;
	}

	open() {
		if (this.animation_type === "slide") {
			this.sidebar.style.transform = "translateX(0)";
		} else {
			this.sidebar.style.width = this.open_width;
		}
		this.showSidebar = true;
		if (this._backdropEl) {
			this._backdropEl.classList.add("list-overlay-backdrop--visible");
		}
	}

	close() {
		if (this.animation_type === "slide") {
			this.sidebar.style.transform = "translateX(100%)";
		} else {
			this.sidebar.style.width = "0";
		}
		this.showSidebar = false;
		if (this._backdropEl) {
			this._backdropEl.classList.remove("list-overlay-backdrop--visible");
		}
	}

	bind_close_button() {
		const collapseSidebarBtn = this.sidebar.getElementsByClassName(
			"collapse-sidebar-overlay"
		)[0];

		collapseSidebarBtn.addEventListener("click", () => {
			this.close();
		});
	}

	set_title(title) {
		this.titleSection.innerText = title;
		this.title = title;
	}
};
